<script setup>
  import { ref } from 'vue'

  const props = defineProps({
    mode: String,
    envVars: Object,
    vitePublinkerApi: String,
    viteLeadclumpApi: String
  })

  const showInfo = ref(false)
  const toggleInfo = () => {
    showInfo.value = !showInfo.value
  }
</script>

<template>
  <div class="env-indicator-wrapper">
    <button
      class="header-btn env-icon-btn"
      @click="toggleInfo"
      :title="`Environment: ${props.mode}`"
    >
      <i class="fa fa-code"></i>
    </button>
    <div v-if="showInfo" class="env-popover">
      <div class="block block-rounded p-0 mb-0">
        <div class="block-content py-2 px-3">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <i class="fa fa-code me-2 opacity-75"></i>
              <span
                >Environment: <strong>{{ props.mode }}</strong></span
              >
            </div>
            <button class="btn-toggle" @click="toggleInfo">
              <i class="fa fa-times"></i>
            </button>
          </div>
          <div class="api-info mt-2">
            <div v-if="Object.keys(props.envVars).length" class="env-vars mb-2">
              <div
                v-for="(value, key) in props.envVars"
                :key="key"
                class="d-flex align-items-center mb-1"
              >
                <i class="fa fa-gear me-2 opacity-75"></i>
                <span class="env-var">
                  {{ key }}: <strong>{{ value }}</strong>
                </span>
              </div>
            </div>
            <div
              v-if="Object.keys(props.envVars).length"
              class="separator mb-2"
            ></div>
            <div class="api-block">
              <div class="api-label">
                <i class="fa fa-link me-1 opacity-75"></i>Publinker API:
              </div>
              <div class="api-url">{{ props.vitePublinkerApi }}</div>
            </div>
            <div class="api-block">
              <div class="api-label">
                <i class="fa fa-link me-1 opacity-75"></i>Leadclump API:
              </div>
              <div class="api-url">{{ props.viteLeadclumpApi }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
  .env-indicator-wrapper {
    position: relative;
    display: inline-block;
  }
  .env-icon-btn {
    padding: 0;
    margin: 0;
    background: none;
    border: none;
    color: inherit;
    font-size: inherit;
    box-shadow: none;
  }
  .env-popover {
    position: absolute;
    top: 40px;
    right: 3px;
    margin-left: 8px;
    min-width: 450px;
    z-index: 2000;
    background: none;
  }
  .block {
    background: rgba(30, 32, 38, 0.96);
    backdrop-filter: blur(8px);
    border: 1px solid rgba(255, 255, 255, 0.08);
    color: #e4e6e7;
    font-size: 0.92rem;
  }
  .btn-toggle {
    background: transparent;
    border: none;
    color: #888;
    font-size: 1rem;
    padding: 0 0.25rem;
    cursor: pointer;
    opacity: 0.7;
    &:hover {
      opacity: 1;
      color: #7a26c1;
    }
  }
  .api-info {
    border-top: 1px solid rgba(255, 255, 255, 0.08);
    padding-top: 0.5rem;
    animation: slideDown 0.2s ease-out;
  }
  .separator {
    height: 1px;
    background: rgba(255, 255, 255, 0.08);
    margin: 0.5rem 0;
  }
  .env-var {
    font-family: monospace;
    font-size: 0.8rem;
  }
  .api-block {
    margin-bottom: 0.5rem;
  }
  .api-label {
    font-size: 0.78rem;
    color: #bdbdbd;
    font-weight: 600;
    margin-bottom: 0.1rem;
    display: flex;
    align-items: center;
  }
  .api-url {
    width: 100%;
    white-space: normal;
    overflow-x: visible;
    text-overflow: initial;
    word-break: break-all;
    font-size: 0.82rem;
    color: #fff;
    opacity: 0.92;
    margin-bottom: 0.1rem;
    margin-left: 1.2rem;
  }
  @keyframes slideDown {
    from {
      opacity: 0;
      transform: translateY(-10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
</style>
